module.exports = "/assets/7846406978478e13caa856b173644328.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/TR.png
// module id = 1866
// module chunks = 0